const local = window.localStorage;

export const removeStorage = function(key) {
  if (!key) return;
  local.removeItem(key);
};

export const getStorage = function(key) {
  let value = key ? local.getItem(key) : null;
  try {
    value = value ? JSON.parse(value) : value;
  } catch (error) {
    console.error(error);
  }
  return value;
};

export const setStorage = function(key, value) {
  if (!key) return;

  const _value = typeof value === "object" ? JSON.stringify(value) : value;
  local.setItem(key, _value);
};



// WEBPACK FOOTER //
// ./src/assets/js/storage.js